import React, {Component, PropTypes} from 'react';
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import Loader from 'react-loader'
import config from '../../config'
import convert from '../../helpers/convert'
import format from '../../helpers/format'
import {
  Link,
  LinkIcon,
  // GetStartedInput,
  // ScoreLabel,
  Grade,
  YesNo
} from '../../components'
import { Row, Col } from 'react-flexbox-grid'
import container from '../../helpers/container'
import * as searchActions from 'redux/modules/search'
import ReactTooltip from 'react-tooltip'

import Styles from './Compare.css'

const noTransform = (v) => v

const checkmarkTransform = (v) => {
  return <YesNo yes={convert.boolean(v)} />
}

const yesNoTransform = (v) => {
  return v === 'true' ? 'Yes' : 'No'
}

const ussifTransform = (v) => {
  const ussifLogo = require('../../../static/images/ussif-icon.png')
  const altText = 'Member of the Forum for Sustainable and Responsible ' +
    'Investing'
  const transformed = (v!=='1.5') ? 'No' :
    (<img styleName='ussif' src={ussifLogo} alt={altText} />)
  return transformed
}

const moneyTransform = (v) => {
  return format.money(v, true, 'USD')
}

const expenseRatioTransform = (v) => {
  // console.log('expenseRatioTransform')
  // console.log(v)
  return v
}

const gradeTransform = (v) => {
  return <Grade grade={v} blocksmall/>
}

const getBenchmark = (v) => {
  const findBenchByLabel = (label, benchmarks) => {
    return benchmarks.filter((benchmark)=> label === benchmark.label)
  }
  const getInitBench = (suggested, benchmarks) => {
    switch (suggested) {
      case 'MSCI ACWI NR USD':
        return findBenchByLabel('ACWI - iShares MSCI ACWI ETF',
                                benchmarks)
      case 'MSCI ACWI Ex USA NR USD':
        return findBenchByLabel('ACWX - iShares MSCI ACWI ex U.S. ETF',
                                benchmarks)
      default:
        return findBenchByLabel('IVV - iShares Core S&P 500 ETF',
                                benchmarks)
    }
  }
  // all benchmarks in config, but only those w/ 10-yr returns
  const benchmarks = config.coreBenchmarks.concat(config.extendedBenchmarks)
  const benchmarksWithPerf = benchmarks.filter((b) => {
    return b.trailing_return_y10 !== ''
  })
  // choose first benchmark based on shareclass suggested benchmark
  const initBench = getInitBench(v, benchmarksWithPerf).pop()
  return initBench
}

const etfBenchmarkTransform = (v) => {
  const initBench = getBenchmark(v)
  return initBench ? initBench.label : 'ERR-BENCH'
}

/**
 * Format return figures to be shown in the table
 * @param {number} val
 * @return <span> with text
 */
const returnsTransform = (val) => {
  if (!val || val === -1000.0) {
    return <span>-</span>
  }
  const valToFixed = (Math.round(val*100)/100.0).toFixed(2)

  // if val is above zero, add a plus sign, make it green
  if (val > 0.0) {
    return <span styleName='green'>+{valToFixed}</span>
  }

  // val is below zero or equal, minus will be shown automatically, make
  // it red
  if (val <= 0.0) {
    return  <span styleName='red'>{valToFixed}</span>
  }

  // we should never reach here
  return <span>ERR</span>
}

const etfBenchmarkReturnsTransform = (v, field, modifier, modifierValue) => {
  if (modifier==='benchmark') {
    const initBench = getBenchmark(modifierValue)
    return returnsTransform(initBench[field])
  } else if (modifier==='benchmarkDiff') {
    const initBench = getBenchmark(modifierValue)
    if (v && v !== -1000.0 && v === initBench[field]) {
      return <span>N/A</span>
    }
    if (!v || v === -1000.0) {
      return <span>-</span>
    }
    return returnsTransform(v - initBench[field])
  }
}

const investmentVehicleIdLength = 11
const SlotIndexes = [1, 2, 3, 4]
const Sections = [
  {
    sectionLabel: 'Shareclass overview',
    sectionLabelTooltip: 'A basic overview of the selected shareclasses.',
    sectionRows: [
      {
        object: 'shareclass',
        label: 'Shareclass ticker',
        field: 'ticker',
      },
      {
        object: 'shareclass',
        label: 'Shareclass type',
        field: 'legal_type',
        transform: format.legalType
      },
      {
        label: 'Fund name',
        field: 'fund_legal_name',
      },
      {
        label: 'Fund family',
        field: 'fund_family_name',
        href: config.routes.families,
        query: 'q'
      },
      {
        label: 'Sustainability mandate',
        field: 'socially_responsible_fund',
        transform: checkmarkTransform
      },
      {
        label: 'US-SIF member',
        field: 'ussif',
        tooltip: 'The Forum for Responsible and Sustainable Investment ' +
          '(US-SIF) is a group advancing sustainable, responsible, and ' +
          'impact investing.',
        transform: ussifTransform
      },
      {
        label: 'Fund holdings as of date',
        field: 'date',
        transform: format.formatDate
      },
      {
        label: 'Fund group',
        field: 'category_group',
      },
      // {
      //   label: 'Fund category',
      //   field: 'morningstar_category_name',
      // },
      // {
      //   label: 'Non-diversification risk',
      //   field: 'non_diversified_fund',
      //   transform: yesNoTransform
      // },
      // {
      //   label: 'Fund inception date',
      //   field: 'oldest_inception_date',
      //   transform: format.formatDate
      // },
      // {
      //   object: 'shareclass',
      //   label: 'Shareclass inception date',
      //   field: 'inception_date',
      //   transform: format.formatDate
      // },
      {
        label: 'Fund net assets',
        field: 'fund_net_assets',
        align: 'r',
        transform: moneyTransform
      },
      {
        object: 'shareclass',
        label: 'Prospectus net expense ratio',
        field: 'prospectus_net_expense_ratio',
        align: 'r',
        transform: expenseRatioTransform
      },
      {
        label: 'Number of holdings',
        field: 'number_of_holding',
        align: 'r',
      },
      {
        label: 'Percent invested in stocks',
        field: 'percent_rated',
        align: 'r',
        transform: format.perc
      },
    ]
  },
  {
    sectionLabel: 'Invest Your Values grades: Environment',
    sectionLabelTooltip: 'Each shareclass is assigned a grade for four ' +
      'environmental issues tracked by Invest Your Values. ' +
      'Click any grade to see details on how it was calculated for that ' +
      'shareclass.',
    sectionRows: [
      {
        object: 'shareclass',
        label: 'Fossil fuels',
        sublabel: 'Investments in coal, oil, and gas energy and utility ' +
          'companies',
        field: 'grade_fossil',
        href: config.links.fff,
        path: 'fossil-fuel-investments',
        title: ' | Fossil Free Funds',
        transform: gradeTransform
      },
      {
        object: 'shareclass',
        label: 'Fossil finance',
        sublabel: 'Investments in banks lending to fossil fuels ' +
          'companies',
        field: 'grade_fossil_bank',
        href: config.links.fff,
        path: 'fossil-fuel-investments',
        title: ' | Fossil Free Funds',
        transform: gradeTransform
      },
      {
        object: 'shareclass',
        label: 'Fossil insurance',
        sublabel: 'Investments in insurance companies insuring fossil fuels ' +
          'companies',
        field: 'grade_fossil_insure',
        href: config.links.fff,
        path: 'fossil-fuel-investments',
        title: ' | Fossil Free Funds',
        transform: gradeTransform
      },
      {
        object: 'shareclass',
        label: 'Deforestation',
        sublabel: 'Investments in deforestation-driving commodities, and ' +
          'related financial companies and consumer brands',
        field: 'grade_deforestation',
        href: config.links.dff,
        path: 'profile',
        title: ' | Deforestation Free Funds',
        transform: gradeTransform
      },
    ]
  },
  {
    sectionLabel: 'Invest Your Values grades: Social',
    sectionLabelTooltip: 'Each shareclass is assigned a grade for eight ' +
      'social issues tracked by Invest Your Values. ' +
      'Click any grade to see details on how it was calculated for that ' +
      'shareclass.',
    sectionRows: [
      {
        object: 'shareclass',
        label: 'Prison industrial complex',
        sublabel: 'Investments in companies involved in the prison and ' +
          'border industries',
        field: 'grade_prison_industrial_complex',
        href: config.links.pff,
        path: 'prison-industrial-complex-investments',
        title: ' | Prison Free Funds',
        transform: gradeTransform
      },
      {
        object: 'shareclass',
        label: 'Military weapons',
        sublabel: 'Investments in military arms manufacturers and services ' +
          'companies',
        field: 'grade_military',
        href: config.links.wff,
        path: 'weapon-investments',
        title: ' | Weapon Free Funds',
        transform: gradeTransform
      },
      {
        object: 'shareclass',
        label: 'Gender equality',
        sublabel: 'Gender equality score group ranking',
        field: 'grade_gender_equality',
        href: config.links.gef,
        path: 'gender-lens-score',
        title: ' | Gender Equality Funds',
        transform: gradeTransform
      },
      {
        object: 'shareclass',
        label: 'Workplace equity',
        sublabel: 'Workplace equity ranking',
        field: 'grade_dei',
        href: config.links.sjf,
        path: 'profile',
        title: ' | Social Justice Funds',
        transform: gradeTransform
      },
      {
        object: 'shareclass',
        label: 'Racial justice',
        sublabel: 'Racial justice ranking',
        field: 'grade_rji',
        href: config.links.sjf,
        path: 'profile',
        title: ' | Social Justice Funds',
        transform: gradeTransform
      },
      {
        object: 'shareclass',
        label: 'LGBTQ+ equity',
        sublabel: 'LGBTQ+ equity ranking',
        field: 'grade_hrc',
        href: config.links.sjf,
        path: 'profile',
        title: ' | Social Justice Funds',
        transform: gradeTransform
      },
      {
        object: 'shareclass',
        label: 'Civilian firearms',
        sublabel: 'Investments in civilian firearms manufacturers and ' +
          'retailers',
        field: 'grade_guns',
        href: config.links.gff,
        path: 'gun-investments',
        title: ' | Gun Free Funds',
        transform: gradeTransform
      },
      {
        object: 'shareclass',
        label: 'Tobacco',
        sublabel: 'Investments in tobacco and e-cigarette manufacturers, ' +
          'and tobacco-promoting entertainment studios',
        field: 'grade_tobacco',
        href: config.links.tff,
        path: 'tobacco-profile',
        title: ' | Tobacco Free Funds',
        transform: gradeTransform
      }
    ]
  },

  // {
  //   sectionLabel: 'Performance overview',
  //   sectionLabelTooltip: 'An overview of financial performance. All ' +
  //     'returns are trailing month end annualized returns, net of expenses ' +
  //     'but not fees.',
  //   sectionRows: [
  //     {
  //       object: 'shareclass',
  //       label: 'Performance as of date',
  //       field: 'performance_as_of_date',
  //       transform: format.formatDate
  //     },
  //     {
  //       object: 'shareclass',
  //       label: 'Annualized returns, 1 month',
  //       field: 'trailing_return_m1',
  //       align: 'r',
  //       transform: returnsTransform
  //     },
  //     {
  //       object: 'shareclass',
  //       label: 'Annualized returns, 3 months',
  //       field: 'trailing_return_m3',
  //       align: 'r',
  //       transform: returnsTransform
  //     },
  //     {
  //       object: 'shareclass',
  //       label: 'Annualized returns, 6 months',
  //       field: 'trailing_return_m6',
  //       align: 'r',
  //       transform: returnsTransform
  //     },
  //     {
  //       object: 'shareclass',
  //       label: 'Annualized returns, 1 year',
  //       field: 'trailing_return_y1',
  //       align: 'r',
  //       transform: returnsTransform
  //     },
  //     {
  //       object: 'shareclass',
  //       label: 'Annualized returns, 3 year',
  //       field: 'trailing_return_y3',
  //       align: 'r',
  //       transform: returnsTransform
  //     },
  //     {
  //       object: 'shareclass',
  //       label: 'Annualized returns, 5 year',
  //       field: 'trailing_return_y5',
  //       align: 'r',
  //       transform: returnsTransform
  //     },
  //     {
  //       object: 'shareclass',
  //       label: 'Annualized returns, 10 year',
  //       field: 'trailing_return_y10',
  //       align: 'r',
  //       transform: returnsTransform
  //     },
  //     {
  //       object: 'shareclass',
  //       label: 'Annualized returns, 15 year',
  //       field: 'trailing_return_y15',
  //       align: 'r',
  //       transform: returnsTransform
  //     },
  //     {
  //       object: 'shareclass',
  //       label: 'Annualized returns, 20 year',
  //       field: 'trailing_return_y20',
  //       align: 'r',
  //       transform: returnsTransform
  //     },
  //     {
  //       object: 'shareclass',
  //       label: 'Annualized returns, year-to-date',
  //       field: 'trailing_return_ytd',
  //       align: 'r',
  //       transform: returnsTransform
  //     },
  //     // {
  //     //   label: 'Fund inception date',
  //     //   field: 'oldest_inception_date',
  //     //   transform: format.formatDate
  //     // },
  //     // {
  //     //   object: 'shareclass',
  //     //   label: 'Annualized returns, since inception',
  //     //   field: 'trailing_return_inception',
  //     //   transform: returnsTransform
  //     // }
  //   ]
  // },
  // {
  //   sectionLabel: 'Benchmarked performance',
  //   sectionLabelTooltip: 'An overview of financial performance compared to ' +
  //     'a benchmark. All returns are trailing month end annualized returns, ' +
  //     'net of expenses but not fees.',
  //   sectionRows: [
  //     {
  //       label: 'Morningstar suggested benchmark',
  //       field: 'morningstar_primary_benchmark',
  //     },
  //     {
  //       label: 'iShares index ETF benchmark',
  //       field: 'morningstar_primary_benchmark',
  //       tooltip: 'Shareclasses are assigned a benchmark ETF by Invest Your ' +
  //         'Values. Each shareclass is assigned to an iShares index fund ' +
  //         'ETF that tracks the Morningstar suggested benchmark.',
  //       transform: etfBenchmarkTransform
  //     },
  //     // {
  //     //   object: 'shareclass',
  //     //   label: 'Benchmark annualized returns, 1 year',
  //     //   field: 'trailing_return_y1',
  //     //   transform: etfBenchmarkReturnsTransform,
  //     //   modifier: 'benchmark',
  //     //   modifierField: 'morningstar_primary_benchmark'
  //     // },
  //     // {
  //     //   object: 'shareclass',
  //     //   label: 'Benchmark annualized returns, 3 year',
  //     //   field: 'trailing_return_y3',
  //     //   transform: etfBenchmarkReturnsTransform,
  //     //   modifier: 'benchmark',
  //     //   modifierField: 'morningstar_primary_benchmark'
  //     // },
  //     // {
  //     //   object: 'shareclass',
  //     //   label: 'Benchmark annualized returns, 5 year',
  //     //   field: 'trailing_return_y5',
  //     //   transform: etfBenchmarkReturnsTransform,
  //     //   modifier: 'benchmark',
  //     //   modifierField: 'morningstar_primary_benchmark'
  //     // },
  //     // {
  //     //   object: 'shareclass',
  //     //   label: 'Benchmark annualized returns, 10 year',
  //     //   field: 'trailing_return_y10',
  //     //   transform: etfBenchmarkReturnsTransform,
  //     //   modifier: 'benchmark',
  //     //   modifierField: 'morningstar_primary_benchmark'
  //     // },
  //     {
  //       object: 'shareclass',
  //       label: '+/- compared to benchmark, 1 year',
  //       field: 'trailing_return_y1',
  //       align: 'r',
  //       transform: etfBenchmarkReturnsTransform,
  //       modifier: 'benchmarkDiff',
  //       modifierField: 'morningstar_primary_benchmark'
  //     },
  //     {
  //       object: 'shareclass',
  //       label: '+/- compared to benchmark, 3 year',
  //       field: 'trailing_return_y3',
  //       align: 'r',
  //       transform: etfBenchmarkReturnsTransform,
  //       modifier: 'benchmarkDiff',
  //       modifierField: 'morningstar_primary_benchmark'
  //     },
  //     {
  //       object: 'shareclass',
  //       label: '+/- compared to benchmark, 5 year',
  //       field: 'trailing_return_y5',
  //       align: 'r',
  //       transform: etfBenchmarkReturnsTransform,
  //       modifier: 'benchmarkDiff',
  //       modifierField: 'morningstar_primary_benchmark'
  //     },
  //     {
  //       object: 'shareclass',
  //       label: '+/- compared to benchmark, 10 year',
  //       field: 'trailing_return_y10',
  //       align: 'r',
  //       transform: etfBenchmarkReturnsTransform,
  //       modifier: 'benchmarkDiff',
  //       modifierField: 'morningstar_primary_benchmark'
  //     }
  //   ]
  // }
]
// set defaults for each section row
const Defaults = {
  transform: noTransform,
  object: 'fund',
  href: null,
  path: null,
  title: null,
  query: null,
  tooltip: null,
  modifier: null,
  modifierField: null,
  align: null
}
Sections.forEach((section, sectionIndex) => {
  // for each section:
  section.sectionRows.forEach((sectionRow, sectionRowIndex) => {
    // for each section row:
    const defaultKeys = Object.keys(Defaults)
    defaultKeys.forEach((defaultKey, defaultKeyIdx) => {
      // for each field in the defaults object:
      if (!sectionRow[defaultKey]) {
        // if, in this row of this section, a value wasn't set for this field:
        // set the value to the default
        sectionRow[defaultKey] = Defaults[defaultKey]
      }
    })
  })
})

// convert query props to state
const stateFromProps = (props) => {
  // s1, s2, etc. are investment_vehicle_ids that define which shareclasses
  // are placed in each slot of the cart
  let state = {
    s1: 'N',
    s2: 'N',
    s3: 'N',
    s4: 'N',
    location: props.location
  }
  SlotIndexes.forEach((idx) => {
    // for each of the slot indexes (1,2,3,4):
    // we'll check to see if that query is present in the location
    const sIdx = 's' + idx.toString()
    if (props.location.query[sIdx]) {
      // if there is are ?s1=, &s2= queries in the location:
      const sId = props.location.query[sIdx]
      if (typeof sId !== 'undefined' && sId !== null &&
          sId.length === investmentVehicleIdLength) {
        // if the query value exists as well, and is length 10:
        // (all investment_vehicle_ids are strings with 10 characters)
        // set this investment_vehicle_id as the value for the related slot
        state[sIdx] = sId
      }
    }
  })
  // empty out the slots object, and null the lastResult object
  state = Object.assign(state, {
    slots:{},
    lastResult: null
  })
  // we now have a state with empty slots, null lastResult, and s1 through s4
  // with investment_vehicle_id if they were present in the location queries,
  // 'N' (null sentinel) if not.
  return state
}

@connect(
  state => ({
    result: state.compare.result,
    loading: state.compare.loading,
    loaded: state.compare.loaded,
    error: state.compare.error,
    cart: state.cart.result,
  }),
  searchActions)
@CSSModules(Styles, {allowMultiple:true})
export default class Compare extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.object,
    compare: PropTypes.func,
    cart: PropTypes.object
  }
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    // use stateFromProps() to gather s1, s2, etc. queries from URL for state
    const initState = stateFromProps(props)
    this.state = initState
  }

  componentWillMount() {
    this.scrollTop()
    // search for the shareclasses specified in state
    this.compareShareclasses(this.state)
  }

  componentWillReceiveProps(props) {
    this.scrollTop()
    if (props.location !== this.state.location) {
      // if the location changed:
      // trigger a new search. first collect query ids
      const state = Object.assign(this.state, stateFromProps(props))
      // set state with empty slots, null lastResult, and query-defined s1...
      this.setState(state)
      // search again
      this.compareShareclasses(state)
    } else if (
      // else if results are present, and results are new:
      props.result &&
      props.result.results &&
      this.state.lastResult !== props.result.results
    ) {
      const slots = {}
      const cart = []
      SlotIndexes.forEach((slotIndex) => {
        // do we have a shareclass id in state, from URL query?
        const slotIndexName = 's'+slotIndex.toString()
        let shareclassId = this.state[slotIndexName]
        shareclassId = shareclassId!=='N' ? shareclassId : null
        const sArr = props.result.results.filter(
          s => s.investment_vehicle_id === shareclassId)
        // unpack the shareclass, fund, and siblings, assuming they exist
        const sShareclass = (sArr && sArr.length) ? sArr[0] : null
        const sFund = sShareclass ? (sShareclass.fund || null) : null
        const sSiblings = sFund ? (sFund.shareclass || null) : null
        // fill slots
        slots[slotIndex] = {
          'shareclass': sShareclass,
          'fund': sFund,
          'siblings': sSiblings
        }
        if (sShareclass && sShareclass.investment_vehicle_id) {
          cart.push({
            id: sShareclass.investment_vehicle_id,
            shareclassStub: {
              name: sShareclass.name,
              ticker: sShareclass.ticker,
              fund_id: sShareclass.fund_id,
              investment_vehicle_id: sShareclass.investment_vehicle_id,
              fund_legal_name: sShareclass.fund_legal_name,
              fund_family_name: sShareclass.fund_family_name,
            }
          })
        } else {
          cart.push({
            id:'N',
            shareclassStub: {}
          })
        }
      })
      this.setState({
        lastResult:props.result.results,
        slots: slots
        // shareclasses: this.state.shareclasses.concat(props.result.results)
      })
      // set these funds (defined from URL query) as the stored cart
      this.props.cartChange(cart, 'N')
    } else if (
      props.result &&
      props.result.results &&
      this.state.lastResult === props.result.results
    ) {
      // chill
      // console.log('we are here')
    } else {
      // const state = Object.assign(this.state, stateFromProps(props))
      // // set state
      // this.setState(state)
      // // search again
      // this.compareShareclasses(state)
    }
  }

  scrollTop = () => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  compareShareclasses = (state) => {
    // call the API. props.compareShareclasses() takes up to 4 investment
    // vehicle ids and calls /shareclasses to get shareclass, fund, and
    // sibling shareclass objects. when API call has resolved,
    // componentWillReceiveProps() will handle state management.
    this.props.compareShareclasses(state.s1, state.s2, state.s3, state.s4)
  }

  replaceShareclass = (shareclass) => {
    // click handler for "replace" link. removes this shareclass from the
    // cart, and navigates to the search page. when user gets to the search
    // page, the "replaced" shareclass will be an empty slot, but the other
    // slots will remain as they were (empty or filled).
    //
    // props.cartChange() takes a cart array and a new shareclass to add or
    // remove. in this case, we want to remove the selected shareclass from
    // the existing cart.
    this.props.cartChange(this.props.cart.results, shareclass)
    // navigate to search page
    this.context.router.push(config.routes.clean)
  }

  generateProfileUrl = (shareclass) => {
    // make ticker safe for URL
    const sTicker = shareclass.ticker || 'N'
    // build a profile URL
    const profileUrl = config.routes.fund +'/' +
      format.sanitize(shareclass.fund_legal_name) + '/' + sTicker + '/' +
      config.profilePath + '/' + shareclass.fund_id + '/' +
      shareclass.investment_vehicle_id
    return profileUrl
  }

  // render a value from the Sections table.
  // values need to exist; need to have a link rendered if needed;
  renderValue = (row, slotIndex) => {
    if (
      row.object &&  // we have an object defined, fund or shareclass
      row.field &&  // we have a field name
      row.transform &&  // we have a transform function
      this.state.slots &&  // we have our slots filled by the API results
      this.state.slots[slotIndex] && // this slot is filled
      this.state.slots[slotIndex][row.object] && // this slot has the object
      this.state.slots[slotIndex][row.object][row.field] // this obj has field
    ) {
      const obj = this.state.slots[slotIndex][row.object]
      const value = obj[row.field]
      let transformed = null
      if (row.modifier) {
        // if there's a modifier, the transform function takes more values
        transformed = row.transform(value, row.field, row.modifier, obj[row.modifierField])
      } else {
        transformed = row.transform(value)
      }

      // dealing with links
      // some links are direct URLs. others need to use the provided value
      // and provided query name to change the href and the title
      //
      // is there an href?
      let { href, title } = row
      const { query, path } = row
      let strong = true
      if (href) {
        // we have an href
        if (query) {
          // if there's an href AND a query:
          // we'll make a safe version of the value for the query
          const safeQueryValue = encodeURIComponent(value)
          href = href + '?' + query + '=' + safeQueryValue
          title = transformed + ' | ' + config.app.title
        }  else if (path) {
          // if there's an href AND a path AND no query
          // that means we're going to one of the other IYV sites
          const sTicker = obj.ticker || 'N'
          const sName = format.sanitize(obj.fund_legal_name)
          href = href + '/fund/' + sName + '/' + sTicker + '/' +
            path + '/' + obj.fund_id + '/' + obj.investment_vehicle_id
          title = obj.fund_legal_name + title
          strong = false
        }
        return (
          <Link to={href} title={title || '--'} strong={strong}>
            {transformed}
          </Link>
        )
      } else {
        // there's no href. return the transformed value with no link
        return transformed
      }
    } else {
      // there's no value. return nothing
      return (
        <div styleName='empty-cell'>/</div>
      )
    }
  }

  renderCartRow = () => {
    return (
      <Row styleName='cart-row'>
        <Col styleName='cart-col' xs={12} sm={3}>
          <div>
            Select shareclasses
            <br/>
            <Link to={config.routes.clean} xstrong={true}>
              <LinkIcon nospace={true} faclass='fa-angle-double-left'/>
              Back to search
            </Link>
          </div>

        </Col>
        { /* render each slot of the cart */
          SlotIndexes.map((slotIndex, slotIndexIdx) => {
            if (
              this.state.slots[slotIndex] &&
              this.state.slots[slotIndex].shareclass &&
              this.state.slots[slotIndex].fund
            ) {
              const { shareclass } = this.state.slots[slotIndex]
              const { fund_family_name, name } = shareclass

              // build a profile URL
              const profileUrl = this.generateProfileUrl(shareclass)

              const familyUrl = config.routes.families + '?q=' +
                fund_family_name

              // build a remove URL
              // we want to remember the existing slot ids
              const saveSlotIds = {}
              SlotIndexes.forEach((sltIndx) => {
                const sltIndexString = 's' + sltIndx.toString()
                if (this.state[sltIndexString]) {
                  saveSlotIds[sltIndx] = this.state[sltIndexString]
                }
              })
              // zero out this slot id
              saveSlotIds[slotIndex] = 'N'
              let removeUrl = config.routes.compare + '?'

              SlotIndexes.forEach((sltIndx) => {
                if (saveSlotIds[sltIndx] && saveSlotIds[sltIndx]!=='N') {
                  removeUrl = removeUrl + 's' + sltIndx + '=' + saveSlotIds[sltIndx] + '&'
                }
              })

              const fileName = format.imgPath(fund_family_name)
              let hasLogo = false
              let companyLogo = null
              try {
                companyLogo = require('../../../static/images/fam/'+fileName+'.png')
                hasLogo = true
              }
              catch (e) {
                // console.log('')
              }

              return (
                <Col
                 styleName='cart-col'
                  xs={12}
                  sm={2.25}
                  key={'cart-col-header-'+slotIndexIdx}
                >
                  <div styleName='cart-title'>
                    <div styleName='section-name'>
                      {name}
                    </div>
                    <br/>
                    <div styleName='section-ticker'>
                      {shareclass.ticker ||  null}
                    </div>
                    <div styleName='no-bold'>
                      <Link
                        to={profileUrl}
                        title={name + ' | ' + config.app.title}
                        xstrong
                      >
                        Profile<LinkIcon />
                      </Link>
                    </div>
                  </div>
                  { /*
                  <Link
                    to={familyUrl}
                    title={fund_family_name + ' | ' + config.app.title}
                    strong
                  >
                    <div styleName='cart-image'>
                      { 
                        hasLogo ?
                          (
                            <img
                              styleName='name-logo'
                              src={companyLogo}
                              alt={fund_family_name}
                            />
                          ) :
                          (<span>{fund_family_name}</span>)
                      }
                    </div>
                  </Link>
                  */ }
                  <div styleName='cart-subtitle'>
                    <Link
                      to={removeUrl}
                      title={'Remove ' + name}
                      strong
                    >
                      Remove<LinkIcon faclass='fa-minus-square-o'/>
                    </Link>
                    &nbsp;|&nbsp;
                    <span
                      onClick={() => {
                        this.replaceShareclass(shareclass)
                      }}
                      title={'Replace ' + name}
                      styleName='cart-subtitle-link'
                    >
                      Replace<LinkIcon faclass='fa-undo'/>
                    </span>
                  </div>
                </Col>
              )
            } else {
              return (
                <Col
                   styleName='cart-col'
                  xs={12}
                  sm={2.25}
                  key={'cart-col-header-'+slotIndexIdx}
                >
                  <div styleName='cart-title' />
                  <Link
                    to={config.routes.clean}
                    title={'Add shareclass | Compare funds | ' + config.app.title}
                   styleName='cart-image'
                  >
                    <div>
                        <LinkIcon faclass='fa-plus-square-o fa-3x'/>
                    </div>
                  </Link>
                  <div styleName='cart-subtitle'>
                    <Link to={config.routes.clean} strong>
                      Add shareclass
                    </Link>
                  </div>
                </Col>
              )
            }
          })
        }
      </Row>
    )
  }

  /**
   * Main render function
   * @return {JSX} page component
   */
  render() {
    if (!this.props.result || !this.state.slots) {
      return (
        <div styleName='main'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={ false }
          />
        </div>
      )
    }
    else if (
      this.props.result &&
      (!this.props.result.results ||
       !this.props.result.results.length)
    ) {
      this.context.router.push(config.routes.notFound)
      return (
        <div styleName='main'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={ false }
          />
        </div>
      )
    }

    const title = 'Compare'
    const url = config.domain + config.routes.compare
    // const sriIcon = require( '../../../static/images/sri.svg' )
    // const ussifLogo = require( '../../../static/images/ussif-icon.png' )
    // const overallScoreIcon = require( '../../../static/images/GEF-icons-gender-equality-score.svg' )
    // const rankIcon = require( '../../../static/images/GEF-icons-peer-rank.svg' )
    // const balanceIcon = require( '../../../static/images/GEF-icons-gender-balance-score.svg' )
    // const policiesIcon = require( '../../../static/images/GEF-icons-gender-equality-policies-rank.svg' )
    // const upArrow = require( '../../../static/images/holdings-up-arrow.svg' )
    // const downArrow = require( '../../../static/images/holdings-down-arrow.svg' )

    // tmp tmp tmp
    // const s1Fund = this.state.slots[1]
    // const s2Fund = this.state.slots[2]

    return (
      <div styleName='page'>
        {container.helmet(title, '', url)}
        <div styleName='container'>

          { /* on mobile, "sorry, feature not yet ready" */ }
          <div styleName={'container-inner visible-xs'}>
            <div styleName='not-yet-wrap'>
              <div styleName='not-yet-headline'>
                Fund compare is coming soon to mobile!
              </div>
              <div styleName='not-yet-info'>
                We're working hard to bring this feature to mobile. For now,
                try visiting this page on your tablet or desktop browser.
              </div>
              <div styleName='not-yet-back'>
                <Link to={config.routes.clean} xstrong={true}>
                  <LinkIcon nospace={true} faclass='fa-angle-double-left'/>
                  Back to search
                </Link>
              </div>
            </div>
          </div>

          { /* actual compare feature only on tablet and desktop */ }
          <div styleName={'container-inner hidden-xs'}>
            <div styleName='page-title'>
              Compare funds
            </div>
            <div styleName='page-info'>
            Select shareclasses and compare. See how funds are graded
            on fossil fuels, deforestation, gender equality, and other
            environmental and social issues, side-by-side.
            </div>
            <div styleName='line'/>
            {this.renderCartRow()}
            <div styleName='line'/>

            { /* render each section */
              Sections.map((section, sectionIdx) => {
                return (
                  <div
                    styleName='data-section-wrap'
                    key={'data-section-wrap-'+sectionIdx}
                  >
                    { /* section head */ }
                    <div styleName='data-section-head'>
                    </div>
                    { /* section body */ }
                    <div styleName='data-section'>
                      <Row styleName='data-section-row'>
                        <Col styleName='data-section-col' xs={12}>
                          { /* is there a tooltip for the section?
                               if so wrap the section label in a <span> with
                               the tooltip, and include a ReactTooltip */
                            section.sectionLabelTooltip ?
                              (
                                <span
                                  data-multiline
                                  data-effect={'solid'}
                                  data-tip={`
                                    <div style='max-width:250px;'>
                                      ${section.sectionLabelTooltip}
                                    </div>
                                  `}
                                  data-html
                                  data-place='right'
                                  data-for={'data-section-label-'+sectionIdx}
                                >
                                  {section.sectionLabel}
                                  <LinkIcon faclass='fa-info-circle' />
                                  <ReactTooltip
                                    id={'data-section-label-'+sectionIdx}
                                  />
                                </span>
                              ) :
                              section.sectionLabel
                          }
                        </Col>
                        <Col xs={12} sm={3} />
                        { /* render each slot for this row */
                          SlotIndexes.map((slotIndex, slotIndexIdx) => {
                            const display = (this.state.slots[slotIndex] &&
                              this.state.slots[slotIndex].shareclass)
                            let sh = null
                            if (display) {
                              sh = this.state.slots[slotIndex].shareclass
                            }
                            return (
                              <Col
                                styleName='data-section-col'
                                xs={12}
                                sm={2.25}
                                key={'data-section-col-'+sectionIdx+'-header-'+slotIndexIdx}
                              >
                                { /* is there a shareclass to display? */
                                  display ?
                                    (
                                      <span>
                                        <span styleName='section-name'>
                                          {sh.name ||  '-'}
                                        </span>
                                        <span styleName='section-ticker'>
                                          {sh.ticker ||  null}
                                        </span>
                                        <span styleName='no-bold'>
                                          <Link
                                            to={this.generateProfileUrl(sh)}
                                            title={
                                              sh.name + ' | ' + config.app.title
                                            }
                                            xstrong
                                          >
                                            Profile<LinkIcon nospace/>
                                          </Link>
                                        </span>
                                      </span>
                                    ) :
                                    null
                                }
                              </Col>
                            )
                          })
                        /* end slot map */ }
                      </Row>
                      { /* render each row for this section */
                        section.sectionRows.map((row, rowIdx) => {
                          return (
                            <Row
                              styleName='data-section-row'
                              key={'data-section-row-'+sectionIdx+'-'+rowIdx}
                            >
                              { /* first col is the row label */ }
                              <Col styleName='data-section-col' xs={12} sm={3}>
                                { /* is there a tooltip for the row label?
                                     if so wrap the row.label in a <span> with
                                     a tooltip, and include a ReactTooltip */
                                  row.tooltip ?
                                    (
                                      <span
                                        styleName='data-section-row-label'
                                        data-multiline
                                        data-effect={'solid'}
                                        data-tip={`
                                          <div style='max-width:250px;'>
                                            ${row.tooltip}
                                          </div>
                                        `}
                                        data-html
                                        data-place='right'
                                        data-for={'data-section-row-'+sectionIdx+'-'+rowIdx}
                                      >
                                        {row.label}
                                        <LinkIcon faclass='fa-info-circle' />
                                        <ReactTooltip
                                          id={'data-section-row-'+sectionIdx+'-'+rowIdx}
                                        />
                                      </span>
                                    ) :
                                    (
                                      <span
                                        styleName='data-section-row-label'
                                      >
                                        {row.label}
                                      </span>
                                    )
                                }
                                { /* is there a sublabel? */
                                  row.sublabel ?
                                    (
                                      <span
                                        styleName='data-section-row-sublabel'
                                      >
                                        {row.sublabel}
                                      </span>
                                    ) :
                                    null
                                }
                              </Col>
                              { /* render each slot for this row */
                                SlotIndexes.map((slotIndex, slotIndexIdx) => {
                                  const style = row.align ?
                                    'col-align-' + row.align :
                                    'col-align-l'
                                  return (
                                    <Col
                                      styleName={'data-section-col ' + style}
                                      xs={12}
                                      sm={2.25}
                                      key={'data-section-col-'+sectionIdx+'-'+rowIdx+'-'+slotIndexIdx}
                                    >
                                      {this.renderValue(row, slotIndex)}
                                    </Col>
                                  )
                                })
                               /* end slot map */ }
                            </Row>
                          )
                        })
                      /* end row map */ }
                    </div>
                    { /* section tail */ }
                    <div styleName='data-section-tail'>
                    </div>
                  </div>
                )
              })
            /* end section map */ }

            <div styleName='page-tail'>
              Select new funds to compare
            </div>
            <div styleName='line'/>
            {this.renderCartRow()}
            <div styleName='line'/>
          </div>
        </div>
      </div>
    )
  }
}
